import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import clarity from '@microsoft/clarity';
import { HelmetProvider } from 'react-helmet-async';
import { clarityProjectId } from './config/clinicConfig';

// Defer bootstrap-icons — not needed for first paint (hero section has no icons)
// @ts-ignore: CRA handles CSS dynamic imports via webpack
import(/* webpackChunkName: "bootstrap-icons" */ 'bootstrap-icons/font/bootstrap-icons.css');

// Defer Bootstrap JS — only needed for dropdowns/modals/collapses, not first paint
// @ts-ignore: no type declarations for bootstrap bundle
import(/* webpackChunkName: "bootstrap-js" */ 'bootstrap/dist/js/bootstrap.bundle.js');

if (process.env.NODE_ENV === 'production') {
  clarity.init(clarityProjectId);
}



const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
